"use strict";

var _Object$keys2 = require("@babel/runtime-corejs3/core-js-stable/object/keys");
var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols");
var _filterInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/filter");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getWidthItems = exports.getWidthBehavior = exports.forEachSize = exports.addOverflowItemsToSizeMap = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));
var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));
var _sort = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/sort"));
var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/keys"));
function ownKeys(e, r) { var t = _Object$keys2(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? Object.defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable import/prefer-default-export */

var getOrderedOverflow = function getOrderedOverflow(mappedOverflow) {
  var _context, _context2;
  return (0, _map.default)(_context = (0, _sort.default)(_context2 = (0, _keys.default)(mappedOverflow)).call(_context2, function (orderA, orderB) {
    return orderA - orderB;
  })).call(_context, function (sortedKey) {
    return mappedOverflow[sortedKey];
  });
};
var mergeOverflowMaps = function mergeOverflowMaps(_ref) {
  var _ref$sm = _ref.sm,
    sm = _ref$sm === void 0 ? {} : _ref$sm,
    _ref$md = _ref.md,
    md = _ref$md === void 0 ? {} : _ref$md,
    _ref$lg = _ref.lg,
    lg = _ref$lg === void 0 ? {} : _ref$lg,
    _ref$xl = _ref.xl,
    xl = _ref$xl === void 0 ? {} : _ref$xl,
    _ref$xxl = _ref.xxl,
    xxl = _ref$xxl === void 0 ? {} : _ref$xxl;
  var bigMap = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, sm), md), lg), xl), xxl);
  return getOrderedOverflow(bigMap);
};
var getWidthItems = exports.getWidthItems = function getWidthItems(overflowMap, currentWidthName) {
  var sm = overflowMap.sm,
    md = overflowMap.md,
    lg = overflowMap.lg,
    xl = overflowMap.xl,
    xxl = overflowMap.xxl;
  switch (currentWidthName) {
    case 'sm':
      {
        return mergeOverflowMaps({
          sm: sm,
          md: md,
          lg: lg,
          xl: xl,
          xxl: xxl
        });
      }
    case 'md':
      {
        return mergeOverflowMaps({
          md: md,
          lg: lg,
          xl: xl,
          xxl: xxl
        });
      }
    case 'lg':
      {
        return mergeOverflowMaps({
          lg: lg,
          xl: xl,
          xxl: xxl
        });
      }
    case 'xl':
      {
        return mergeOverflowMaps({
          xl: xl,
          xxl: xxl
        });
      }
    case 'xxl':
      {
        return mergeOverflowMaps({
          xxl: xxl
        });
      }
    default:
      return [];
  }
};

// eslint-disable-next-line default-param-last
var getWidthBehavior = exports.getWidthBehavior = function getWidthBehavior() {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    sm = _ref2.sm,
    md = _ref2.md,
    lg = _ref2.lg,
    xl = _ref2.xl,
    xxl = _ref2.xxl;
  var currentWidthName = arguments.length > 1 ? arguments[1] : undefined;
  var behavior;
  switch (currentWidthName) {
    case 'sm':
      {
        behavior = sm;
        if (behavior) break;
      }
    // eslint-disable-next-line no-fallthrough
    case 'md':
      {
        behavior = md;
        if (behavior) break;
      }
    // eslint-disable-next-line no-fallthrough
    case 'lg':
      {
        behavior = lg;
        if (behavior) break;
      }
    // eslint-disable-next-line no-fallthrough
    case 'xl':
      {
        behavior = xl;
        if (behavior) break;
      }
    // eslint-disable-next-line no-fallthrough
    case 'xxl':
      {
        // allow xxl to inherit xl if not defined - we introduced xxl after the breakpoints
        // prop was already established, this is to prevent
        // the breaking change of xxl being required
        behavior = xxl || xl;
        if (behavior) break;
      }
    // eslint-disable-next-line no-fallthrough
    default:
      break;
  }
  return behavior;
};
var SIZES = ['sm', 'md', 'lg', 'xl', 'xxl'];
var forEachSize = exports.forEachSize = function forEachSize(callback) {
  return SIZES.forEach(callback);
};
var addOverflowItemsToSizeMap = exports.addOverflowItemsToSizeMap = function addOverflowItemsToSizeMap(aSizeMap, itemsOrder, items) {
  if (!aSizeMap[itemsOrder]) {
    // eslint-disable-next-line no-param-reassign
    aSizeMap[itemsOrder] = [];
  }
  aSizeMap[itemsOrder].push(items);
};